module.exports = __webpack_public_path__ + "static/media/kmerrilyhome-IG.24c0379a.PNG";